<template>
  <div id="sig-container" class="block full form-horizontal">
    <div class="loader" v-if="loading">
      <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
    </div>
    <table-component :data="archivos" @click-event="clickEvent" pagination>
      <table-column
        slot="label"
        :label="'Nombre'"
        v-bind:value="'nombre'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Extención'"
        v-bind:value="'extencion'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Tamaño'"
        v-bind:value="'peso'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Fecha exportación'"
        v-bind:value="'fecha'"
      ></table-column>

      <table-column slot="label" :label="'Acciones'" :icon="'fa'">
        <template
          slot="icon"
          :icon="'fa fa-download'"
          :class="'btn btn-sm btn-primary'"
          :slug="'descargar-archivo'"
          :tooltip="'Descargar Archivo'"
        ></template>
        <template
          slot="icon"
          :icon="'fa fa-trash'"
          :class="'btn btn-sm btn-primary'"
          :slug="'eliminar-archivo'"
          :tooltip="'Eliminar Archivo'"
        ></template>
      </table-column>
    </table-component>
    <div class="form-actions">
      <button class="btn btn-primary" @click="index()" :disabled="loading">
        Aplicar</button
      >&nbsp;
      <button
        class="btn btn-primary"
        @click="descargarConsulta()"
        :disabled="loading"
      >
        Descargar excel
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  name: "Archivos",
  data: () => {
    return {
      params: {
        paginar: false,
        page: 1,
        row: 25,
      },
    };
  },
  computed: {
    ...mapGetters({
      archivos: "ventaCartera/archivos",
      loading: "ventaCartera/loading",
    }),
  },
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
  },
  methods: {
    index() {
      this.$store.commit("ventaCartera/setArchivos", []);
      this.$store.dispatch("ventaCartera/listar", { params: this.params });
    },
    donwload(data) {
      this.$store.commit("ventaCartera/setLoading", true);
      this.$store
        .dispatch("ventaCartera/download", data)
        .then((response) => {
          saveAs(
            new Blob([response.data], { type: "text/csv" }),
            data.nombre_completo
          );
          this.$store.commit("ventaCartera/setLoading", false);
          this.$notify({
            title: "Archivo procesado",
            content:
              "Se ha exportado con exito la información para venta de cartera.",
            type: "success",
          });
        })
        .catch((error) => {
          this.$store.commit("ventaCartera/setLoading", false);
          this.$notify({
            title: "Fallo al exportar",
            content:
              "Se produjo un error al tratar de exportar el archivo, por favor inténtelo mas tarde." +
              error,
            type: "danger",
          });
        });
    },
    eliminar(data) {
      this.$store.commit("ventaCartera/setLoading", true);
      this.$store
        .dispatch("ventaCartera/eliminar", data)
        .then(() => {
          this.$store.commit("ventaCartera/setLoading", false);
          this.$notify({
            title: "Archivo eliminado",
            content: "Se ha eliminado con exito el archivo.",
            type: "success",
          });
          this.index();
        })
        .catch((error) => {
          this.$store.commit("ventaCartera/setLoading", false);
          this.$notify({
            title: "Fallo al eliminar",
            content:
              "Se produjo un error al tratar de eliminar el archivo, por favor inténtelo mas tarde." +
              error,
            type: "danger",
          });
          this.index();
        });
    },
    descargarConsulta() {
      let data = JSON.stringify(this.archivos);

      data = JSON.parse(data);

      data.forEach((element) => {
        delete element.archivo;
      });

      data = XLSX.utils.json_to_sheet(data, {
        header: ["nombre", "extencion", "peso", "fecha", "nombre_completo"],
      });

      data["A1"].v = "Nombre";
      data["B1"].v = "Extención";
      data["C1"].v = "Tamaño";
      data["D1"].v = "Fecha exportación";
      data["E1"].v = "Nombre completo";

      var workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, data, "Archivos");
      var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
      var wbout = XLSX.write(workbook, wopts);
      saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "Exportaciones_Venta_Cartera.xlsx"
      );
    },
    clickEvent(data, slug) {
      switch (slug) {
        case "descargar-archivo":
          this.donwload(data);
          break;
        case "eliminar-archivo":
          if (confirm("¿Está seguro que desea eliminar este archivo?")) {
            this.eliminar(data);
          }
          break;
      }
    },
  },
  mounted() {
    this.index();
  },
};
</script>